import * as React from "react";
import ButtonLink from "../../ButtonLink";
import Close from "../../icons/Close";
const ModalCloseButton = ({
  onClick,
  dataTest,
  title
}) => {
  return /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: onClick,
    size: "normal",
    iconLeft: /*#__PURE__*/React.createElement(Close, null),
    dataTest: dataTest,
    type: "secondary",
    title: title
  });
};
export default ModalCloseButton;